import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/settings/workspace')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/settings/organization',
      params: { organizationName: params.organizationName },
    });
  },
});
